'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowBigRight } from 'lucide-react';
import { SmartIcon } from '@/shared/blocks/common';
import { ScrollAnimation } from '@/shared/components/ui/scroll-animation';
import { cn } from '@/shared/lib/utils';
import { Section } from '@/shared/types/blocks/landing';
export function FeaturesStep(t0) {
  const $ = _c(24);
  const {
    section,
    className
  } = t0;
  const t1 = section.id;
  let t2;
  if ($[0] !== className || $[1] !== section.className) {
    t2 = cn("py-16 md:py-24", section.className, className);
    $[0] = className;
    $[1] = section.className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== section.label) {
    t3 = <span className="text-primary">{section.label}</span>;
    $[3] = section.label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== section.title) {
    t4 = <h2 className="text-foreground mt-4 text-4xl font-semibold">{section.title}</h2>;
    $[5] = section.title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== section.description) {
    t5 = <p className="text-muted-foreground mt-4 text-lg text-balance">{section.description}</p>;
    $[7] = section.description;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <ScrollAnimation><div className="mx-auto max-w-2xl text-center">{t3}{t4}{t5}</div></ScrollAnimation>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== section.items) {
    t7 = section.items?.map((item, idx) => <div className="space-y-6" key={idx}><div className="text-center"><span className="mx-auto flex size-6 items-center justify-center rounded-full bg-zinc-500/15 text-sm font-medium">{idx + 1}</span><div className="relative"><div className="mx-auto my-6 w-fit">{item.icon && <SmartIcon name={item.icon as string} size={24} />}</div>{idx < (section.items?.length ?? 0) - 1 && <ArrowBigRight className="fill-muted stroke-primary absolute inset-y-0 right-0 my-auto mt-1 hidden translate-x-[150%] drop-shadow @3xl:block" />}</div><h3 className="text-foreground mb-4 text-lg font-semibold">{item.title}</h3><p className="text-muted-foreground text-balance">{item.description}</p></div></div>);
    $[13] = section.items;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <ScrollAnimation delay={0.2}><div className="mt-20 grid gap-12 @3xl:grid-cols-4">{t7}</div></ScrollAnimation>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="m-4 rounded-[2rem]"><div className="@container relative container">{t6}{t8}</div></div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== section.id || $[21] !== t2 || $[22] !== t9) {
    t10 = <section id={t1} className={t2}>{t9}</section>;
    $[20] = section.id;
    $[21] = t2;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}